import { type ReactNode } from "react";

import { cn } from "@/src/lib/utils";

export interface FormErrorProps {
  children: ReactNode;
  className?: string;
}

export function FormError({ children, className }: FormErrorProps) {
  return (
    <div
      className={cn(
        "rounded-sm border border-error/20 bg-error/10 px-3 py-2 text-sm text-error",
        className,
      )}
    >
      {children}
    </div>
  );
}
